import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import ProgramSendMessageWrite from '../sendMessageWrite';
import LocalText from '@/localization/local_text';
import { programBoardList } from '@/network/apis/apiUri';
import NavData from '@/config/data/nav/nav_data.json';
import { MainHead, Pagination } from '../common';
import { useAuthnReducer } from '@/hook';
import AuthnComponent from '../../../common/login';

export default function ProgramSendMessage(props) {
  const { mode, history, selBoard, anchorTitle } = props;
  const location = useLocation();
  const search = new URLSearchParams(location.search);

  const isWriteMode = search.get('type') === 'write';

  const userData = JSON.parse(localStorage.getItem('userData'));

  const [topData, setTopData] = useState();
  const [normalData, setNormalData] = useState();
  const [pageInfo, setPageInfo] = useState();

  const [writeMode, setWriteMode] = useState(isWriteMode);
  const [itemId, setItemId] = useState();

  const [modalState, modalDispatch] = useAuthnReducer('CLOSE');

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchParams = new URLSearchParams(history.location.search);

    const formData = new FormData(e.currentTarget);

    const searchOpt = formData.get('searchOpt');
    const searchText = formData.get('searchText') ?? '';

    searchParams.set('searchOpt', searchOpt);
    searchParams.set('searchText', searchText);
    searchParams.delete('page');

    history.push(`?${searchParams.toString()}`);
  };

  const handlePageBtn = (e) => {
    const { value } = e.currentTarget;

    const searchParams = new URLSearchParams(history.location.search);
    const nowPage = searchParams.get('page') ?? 1;

    if (value === 'nextPage') {
      searchParams.set('page', +nowPage + 1);
    }
    if (value === 'prevPage') {
      searchParams.set('page', +nowPage - 1);
    }
    if (value === 'firstPage') {
      searchParams.set('page', 1);
    }
    if (value === 'lastPage') {
      searchParams.set('page', pageInfo.total_page_count);
    }
    if (!isNaN(Number(value))) {
      searchParams.set('page', value);
    }

    history.push(`?${searchParams.toString()}`);
  };
  const handleWriteBtn = () => {
    if (userData) {
      setWriteMode(true);
      history.push('?type=write');
      return;
    }
    modalDispatch('LOGIN');
  };

  const onClickEditBtn = () => {
    modalDispatch('MODIFY');
  };

  const handleWriteClose = () => {
    setWriteMode(false);
    setItemId(undefined);
  };

  const handleBlindItem = (v, e) => {
    if (userData) {
      if (userData.nickName === v.writeUserNick) {
        setWriteMode(true);
        setItemId(v.itemId);
        history.push('?type=write');
        return;
      }
    }
    if (mode === 'en') alert('This is a private post. Please log in.');
    if (mode === 'ko') alert('비공개 게시글입니다. 로그인을 해주세요.');
  };

  useEffect(() => {
    if (!writeMode) {
      const searchParams = new URLSearchParams(history.location.search);
      const page = searchParams.get('page') ?? 1;
      const searchText = searchParams.get('searchText') ?? null;
      const searchOpt = searchText ? searchParams.get('searchOpt') ?? null : null;

      programBoardList({
        lan_code: mode,
        board_id: selBoard.boardId,
        key_word: 'top_allow',
        reg_order: 'desc',
        page_info: { row_count: -1, number: 0 },
      }).then((res) => {
        if (res.status === 200) {
          const _data = res.data.item.map((el) => ({
            key: `sendMsg_top_${el.board_item_id}`,
            itemId: el.board_item_id,
            editUserId: el.board_user_id,
            writeUserId: el.writer_id,
            writeUserNick: el.writer_nick_name,
            title: el.title,
            regDate: el.reg_date ? el.reg_date.slice(0, 10) : '',
          }));
          if (_data.length) setTopData(_data);
          else setTopData(undefined);
        }
      });

      programBoardList({
        lan_code: mode,
        board_id: selBoard.boardId,
        key_word: searchOpt,
        word: searchText,
        reg_order: 'desc',
        page_info: { row_count: 10, number: page - 1 },
      }).then((res) => {
        if (res.status === 200) {
          const _pageInfo = res.data.paging_info;
          const _data = res.data.item.map((el, i) => ({
            no: _pageInfo.total_item_count - 10 * _pageInfo.number - i,
            key: `sendMsg_normal_${el.board_item_id}`,
            itemId: el.board_item_id,
            editUser: el.board_user_id,
            writeUser: el.writer_id,
            writeUserNick: el.writer_nick_name,
            title: el.title,
            regDate: el.reg_date ? el.reg_date.slice(0, 10) : '',
            isBlind: el.is_blind,
          }));
          if (_data.length) setNormalData(_data);
          else setNormalData(undefined);
          setPageInfo(_pageInfo);
        }
      });
    }
  }, [history.location, writeMode]);

  useEffect(() => {
    setWriteMode(isWriteMode);
  }, [isWriteMode]);

  if (writeMode)
    return (
      <ProgramSendMessageWrite
        mode={mode}
        history={history}
        selBoard={selBoard}
        handleWriteClose={handleWriteClose}
        itemId={itemId}
      />
    );
  return (
    <div id="CommonProgramBoard" className="commonProgramBoard">
      {modalState.open && <AuthnComponent mode={mode} state={modalState.state} dispatch={modalDispatch} />}
      <MainHead title={selBoard.title} mode={mode} handleSubmit={handleSubmit} />
      <div className="commonProgramBoard_content">
        {userData && (
          <div className="userButton">
            <div className="userButton_edit">
              <button type="button" className="userButton_edit_btn add-img" onClick={onClickEditBtn}>
                <LocalText txt={'common_board_edit'} />
              </button>
            </div>
            <div className="userButton_write">
              <button type="button" className="userButton_write_btn" onClick={handleWriteBtn}>
                <LocalText txt={'common_board_write'} />
              </button>
            </div>
          </div>
        )}
        {!userData && (
          <div className="userButton">
            <div className="userButton_write">
              <button type="button" className="userButton_write_btn" onClick={handleWriteBtn}>
                <LocalText txt={'login_btn'} />
              </button>
            </div>
          </div>
        )}
        <table className="table">
          <caption className="sr-only"></caption>
          <colgroup>
            <col width="8%" />
            <col width="*" />
            <col width="20%" />
            <col width="12%" />
          </colgroup>
          <thead className="table_head">
            <tr className="table_row">
              <th className="table_row_head" scope="col">
                NO
              </th>
              <th className="table_row_head" scope="col">
                Title
              </th>
              <th className="table_row_head" scope="col">
                WRITER
              </th>
              <th className="table_row_head" scope="col">
                DATE
              </th>
            </tr>
          </thead>
          <tbody className="table_body">
            {topData &&
              topData.map((v, i) => (
                <tr className="table_row" key={v.key} style={{ fontWeight: 'bold' }}>
                  <td className="table_row_data" style={{ textAlign: 'center' }}>
                    TOP
                  </td>
                  <td className="table_row_data">
                    {userData?.nickName === v.writeUserNick || v.isBlind ? (
                      <button
                        type="button"
                        value={v.writeUserNick}
                        className="table_row_data--button"
                        onClick={handleBlindItem.bind(null, v)}
                        dangerouslySetInnerHTML={{
                          __html: v.title,
                        }}
                      />
                    ) : (
                      <Link
                        to={`${NavData['RADIO_MAIN'].path}/${selBoard.programId}/board/${selBoard.boardId}/${v.itemId}`}
                        className="link"
                        dangerouslySetInnerHTML={{
                          __html: v.title,
                        }}
                        title={anchorTitle}
                      />
                    )}
                  </td>
                  <td className="table_row_data" style={{ textAlign: 'center' }}>
                    {v.writeUserNick}
                  </td>
                  <td className="table_row_data" style={{ textAlign: 'center' }}>
                    {v.regDate}
                  </td>
                </tr>
              ))}
            {normalData &&
              normalData.map((v, i) => (
                <tr className="table_row" key={v.key}>
                  <td className="table_row_data" style={{ textAlign: 'center' }}>
                    {v.no}
                  </td>
                  <td className="table_row_data">
                    {userData?.nickName === v.writeUserNick || v.isBlind ? (
                      <button
                        type="button"
                        value={v.writeUserNick}
                        className="table_row_data--button"
                        onClick={handleBlindItem.bind(null, v)}
                        dangerouslySetInnerHTML={{
                          __html: v.title,
                        }}
                      />
                    ) : (
                      <Link
                        to={`${NavData['RADIO_MAIN'].path}/${selBoard.programId}/board/${selBoard.boardId}/${v.itemId}`}
                        className="link"
                        dangerouslySetInnerHTML={{
                          __html: v.title,
                        }}
                        title={anchorTitle}
                      />
                    )}
                  </td>
                  <td className="table_row_data" style={{ textAlign: 'center' }}>
                    {v.writeUserNick}
                  </td>
                  <td className="table_row_data time-fs-fixed" style={{ textAlign: 'center' }}>
                    {v.regDate}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {pageInfo && (
        <Pagination nowPage={pageInfo.number} totalPage={pageInfo.total_page_count} handlePageBtn={handlePageBtn} />
      )}
    </div>
  );
}
